import clsx from 'clsx'
import { useRouter } from 'next/router'
import React from 'react'
import useStyles from './RawHtml.styles'
import { Box } from '@mui/material'

type Props = {
  content?: string | null | React.ReactNode
  className?: string
  dataTestId?: string
}

const RawHtml = React.forwardRef<HTMLDivElement, Props>(({ content, className, dataTestId }, ref) => {
  const router = useRouter()
  const { classes } = useStyles()

  const handleAnchorClick = (e: React.SyntheticEvent<HTMLElement>) => {
    const targetLink = (e.target as HTMLElement).closest('a')
    if (
      targetLink?.href &&
      targetLink.hostname === window.location.hostname &&
      targetLink.protocol === window.location.protocol
    ) {
      // Use router.push for links with same site
      e.preventDefault()
      router?.push(targetLink.pathname)
    }
  }
  let contentElement: React.ReactNode = null

  if (content) {
    if (typeof content === 'string') {
      contentElement = (
        <Box
          ref={ref}
          className={clsx(classes.content, className)}
          onClick={handleAnchorClick}
          onKeyDown={handleAnchorClick}
          dangerouslySetInnerHTML={{ __html: content }}
          data-testId={dataTestId}
        ></Box>
      )
    } else {
      contentElement = (
        <Box
          ref={ref}
          className={clsx(classes.content, className)}
          onClick={handleAnchorClick}
          onKeyDown={handleAnchorClick}
          data-testId={dataTestId}
        >
          {content}
        </Box>
      )
    }
  }

  return contentElement
})
RawHtml.displayName = 'RawHtml'

export default RawHtml
